<app-dashboard-sidemenu></app-dashboard-sidemenu>

<!-- Start Main Content Wrapper Area -->
<div class="main-content d-flex flex-column">

    <app-dashboard-navbar></app-dashboard-navbar>

    <!-- Breadcrumb Area -->
    <div class="breadcrumb-area" *ngFor="let Content of breadcrumb;">
        <h1>{{Content.title}}</h1>
        <ol class="breadcrumb">
            <li class="item"><a routerLink="/">Home</a></li>
            <li class="item"><a routerLink="dashboard">{{Content.subTitle}}</a></li>
            <li class="item">{{Content.title}}</li>
        </ol>
    </div>
    <!-- End Breadcrumb Area -->

    <!-- Start -->
    <div class="row">
        <div class="col-lg-6 col-md-12">
            <div class="my-profile-box">
                <h3>Profile Details</h3>
    
                <form>
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group profile-box">
                                <!-- <img src="assets/img/user1.jpg" alt="image"> -->
                                <img src="{{userAccountDetails.PROFILE_PICTURE}}" alt="image">
                                <!-- <div class="file-upload">
                                    <input type="file" name="file" id="file" class="inputfile" 
                                    (change)="onUploadSuccess($event)"
                                    />
                                    <label for="file"><i class='bx bx-upload'></i> Upload Photo</label>
                                </div> -->
                            </div>
                        </div>

                        <div class="add-listings-box">
                            <h3>Profile Picture</h3>
                            <div>
                                <div class="col-md-12">
                                    <ol id="ol-uploadimg-imgname">
                                        <li *ngFor="let fileName of uploadedLogoFilesName; let ndx=index" [id]="'opt-uploadimg-imgname-'+ndx"><a [id]="'a-imgname-'+ndx" href="FoxDocumentDirectory\RequestForOrder\UploadImages\{{fileName}}"
                                                target="_blank">{{fileName}}</a></li>
                                    </ol>
                                </div>
                                
                                <div class="clearfix"></div>
                                
                                <dropzone id="p-uploadimg-dropzone" [config]="config" [message]="'Click or Drag Images and Documents here to upload (.pdf, .png, .jpg/.jpeg, .tif/.tiff, .bmp)'" (maxFilesExceeded)="onMaxFilesExceeded()"
                        (maxFilesReached)="onMaxFilesReached()" (removedFile)="onRemoveFile($event)" (error)="onUploadError($event)"
                        (success)="onUploadSuccess($event, true)" (canceled)="onCanceled($event)"></dropzone>
                            </div>
                        </div>
    
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Your Name</label>
                                <input type="text" class="form-control" 
                                id="NAME"
                                name="name"
                                [(ngModel)]="userAccountDetails.NAME"
                                >
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>User Name</label>
                                <input type="text" class="form-control" 
                                id="User_Name"
                                name="User_Name"
                                [(ngModel)]="userAccountDetails.User_Name"
                                disabled
                                >
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Email</label>
                                <input type="text" class="form-control" 
                                id="EMAIL_ADDRESS"
                                name="EMAIL_ADDRESS"
                                [(ngModel)]="userAccountDetails.EMAIL_ADDRESS"
                                disabled
                                >
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Email  <span id="email-status" class="label"></span></label>
                                <br>
                                <button type="submit" 
                                (click)="verifyUserDetails()">Email Verification</button>

                            </div>
                        </div>
                    
                        
                        <div class="col-xl-6 col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Phone</label>
                                <input type="text" class="form-control" 
                                id="PHONE_NUMBER"
                                name="PHONE_NUMBER"
                                [(ngModel)]="userAccountDetails.PHONE_NUMBER"
                                >
                            </div>
                        </div>
                        
                        <div class="col-xl-6 col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Address</label>
                                <input type="text" class="form-control" 
                                id="ADDRESS"
                                name="ADDRESS"
                                [(ngModel)]="userAccountDetails.ADDRESS"
                                >
                            </div>
                        </div>
                        
                        <div class="col-xl-6 col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Website</label>
                                <input type="text" class="form-control" 
                                >
                            </div>
                        </div>
                        
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Bio</label>
                                <textarea cols="30" rows="6" 
                                id="USER_BIO"
                                name="USER_BIO"
                                [(ngModel)]="userAccountDetails.USER_BIO"
                                placeholder="Short description about you..." class="form-control"></textarea>
                            </div>
                        </div>

                        <div class="col-xl-6 col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Facebook URL</label>
                                <input type="text" class="form-control" 
                                id="FACEBOOK_LINK"
                                name="FACEBOOK_LINK"
                                [(ngModel)]="userAccountDetails.FACEBOOK_LINK" 
                                placeholder="https://www.facebook.com/">
                            </div>
                        </div>
                        
                        <div class="col-xl-6 col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Twitter URL</label>
                                <input type="text" 
                                id="TWITTER_LINK"
                                name="TWITTER_LINK"
                                [(ngModel)]="userAccountDetails.TWITTER_LINK" 
                                class="form-control" placeholder="https://twitter.com/">
                            </div>
                        </div>
                        
                        <div class="col-xl-6 col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Linkedin URL</label>
                                <input type="text" class="form-control" 
                                id="LINKEDIN_LINK"
                                name="LINKEDIN_LINK"
                                [(ngModel)]="userAccountDetails.LINKEDIN_LINK" 
                                placeholder="https://www.linkedin.com/">
                            </div>
                        </div>
                        
                        <div class="col-xl-6 col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Instagram URL</label>
                                <input type="text" class="form-control" 
                                id="INSTAGRAM_LINK"
                                name="INSTAGRAM_LINK"
                                [(ngModel)]="userAccountDetails.INSTAGRAM_LINK" 
                                placeholder="https://instagram.com/">
                            </div>
                        </div>
    
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <button type="submit" (click)="saveUserDetails()">Save Change</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    
        <div class="col-lg-6 col-md-12">
            <div class="my-profile-box">
                <h3>Change Password</h3>
    
                <form>
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>Current Password</label>
                                <input type="password" class="form-control" 
                                id="PASSWORD"
                                name="PASSWORD"
                                [(ngModel)]="userAccountDetails.PASSWORD"
                                >
                            </div>
                        </div>
                        
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <label>New Password</label>
                                <input type="password" 
                                name="NEW_PASSWORD"
                                [(ngModel)]="userAccountDetails.NEW_PASSWORD"
                                class="form-control">
                            </div>
                        </div>
                        
                        
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <label><i class="bi bi-pass"></i> Verify Password</label>
                                <div class="input-group">
                                    <input [type]="showVerifyPassword ? 'text' : 'password'" class="form-control" placeholder="Enter your password"
                                        [(ngModel)]="userAccountDetails.CONFIRM_PASSWORD" name="VERIFY_PASSWORD">
                                    <span class="input-group-text">
                                        <i class="bi" [ngClass]="showVerifyPassword ? 'bi-eye-slash' : 'bi-eye'" (click)="toggleVerifyPasswordVisibility()"></i>
                                    </span>
                                </div>
                                <small *ngIf="passwordMismatch" style="color:red;">Passwords do not match</small>
                            </div>
                        </div>
    
                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <button type="submit">Change Password</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <!-- End -->

    <!-- Popup Modal -->
<div class="custom-modal" *ngIf="isPopupVisible">
    <div class="popup-overlay" ></div>
    <div class="modal-content">
        <div class="modal-header">
        
            <div class="modal-title" style="margin-bottom: 0px !important;">
                <h2>OTP Verification</h2>
                <p>Verify the OTP using your email.</p>
                <p style="color: red;">Please wait a few moments to receive the email and do not close the popup.</p>
                <label style="color: red;" *ngIf="this.invalidOTP == true">Invalid OPT</label>
                <input  class="form-control" 
                placeholder="Enter your OTP"
                 [(ngModel)]="this.OTP" name="VERIFY_PASSWORD" maxlength="6"
                 pattern="[0-9]*" 
                 inputmode="numeric" 
                 (input)="onInput($event)"
                 type="tel"
                 >
            </div>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn"  data-bs-dismiss="modal" aria-label="Close" (click)="closeModelClose()">No</button>
            <button class="accept-btn"   data-bs-dismiss="modal" aria-label="Close" (click)="verifyOTPDetails()">Yes</button>
        </div>
    </div>
</div>

    <div class="flex-grow-1"></div>
    
    <app-copyrights></app-copyrights>

</div>
<!-- End Main Content Wrapper Area -->